import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Space,
  Typography,
} from "antd";
import React from "react";
import Icon from "assets/icons";
import {FORMAT_TIME} from "types/enums";
import {formatDateToString} from "helper/common";
import moment from "moment";
const FormList = props => {
  const {form, name, suffix, label, styleLabel} = props;
  return (
    <Row gutter={[16, 16]}>
      <Form.List name={[...name, "Result"]}>
        {(fields, {add, remove}, {errors}) => (
          <Row gutter={[16, 8]}>
            <Col span={2}>
              <Typography.Text strong style={styleLabel}>
                {label}
              </Typography.Text>{" "}
            </Col>

            <Col span={1}>
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  add({
                    value: null,
                    min: "",
                  });
                }}
              >
                <Icon.add></Icon.add>
              </Button>
            </Col>
            <Col flex={"auto"}>
              <Space direction="vertical" style={{width: "100%"}}>
                {fields.map((field, index) => (
                  <Row gutter={[16, 20]}>
                    <Col flex={"auto"}>
                      <Row gutter={[16, 16]}>
                        <Col span={12}>
                          <Form.Item name={[field.name, "value"]}>
                            {label != "Huyết áp" && (
                              <InputNumber
                                addonBefore="Kết quả"
                                onChange={e => {
                                  form.setFieldValue(
                                    [...name, "Result", field.name, "min"],
                                    formatDateToString(
                                      moment(),
                                      FORMAT_TIME.dateTime
                                    )
                                  );
                                }}
                                addonAfter={suffix}
                                placeholder="Nhập"
                                style={{width: "100%"}}
                              ></InputNumber>
                            )}
                            {label == "Huyết áp" && (
                              <Input
                                addonBefore="Kết quả"
                                onChange={e => {
                                  form.setFieldValue(
                                    [...name, "Result", field.name, "min"],
                                    formatDateToString(
                                      moment(),
                                      FORMAT_TIME.dateTime
                                    )
                                  );
                                }}
                                addonAfter={suffix}
                                placeholder="Nhập"
                                allowClear
                                style={{width: "100%"}}
                              ></Input>
                            )}
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name={[field.name, "min"]}>
                            <Input
                              addonBefore="Lúc "
                              addonAfter={<Icon.clock />}
                              allowClear
                              style={{width: "100%"}}
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      span={1}
                      style={{
                        padding: 0,
                        margin: "auto",
                        textAlign: "end",
                      }}
                    >
                      {/* Kết quả{" "} */}
                      <Button
                        size="small"
                        danger={true}
                        type="primary"
                        onClick={() => {
                          remove(index);
                        }}
                      >
                        <Icon.sub></Icon.sub>
                      </Button>
                    </Col>
                  </Row>
                ))}
              </Space>
            </Col>
          </Row>
        )}
      </Form.List>
      {/* </div> */}
      {/* </Col> */}
    </Row>
  );
};
export default FormList;
